<template>
	<PageLoading :is-loading="isLoading"></PageLoading>
	<SideComponent @scrollto="scroll"></SideComponent>
	<!-- <Search msg="search" search-wraper-width="auto" select-width="auto!important" margin-top="0px"/> -->
	<div class="container" ref="viewBox">
		<div class="header-container">
			<div class="search-swiper-container">				
				<Swiper :list="banners"/>
				<search-bar-video @search="getVideo"></search-bar-video>
			</div>
		</div>
		<div class="content">
			<div class="enclosure" style="">
				<section class="section masonry">
					<div class="masonry-column" v-for="(column, colIndex) in videoColumns" :key="colIndex">
						<div class="_1Aw4E" v-for="item in column" :key="item.id">
							<div @click="toDetail(item.id)" style="width:100%;">
								<video v-if="isMobile"
								    :poster="item.thumb"
								    preload="none"
								    muted
								    :alt="item.title"
								    :style="getVideoAspectStyle(item)"
								    controlslist="nodownload"
								    oncontextmenu="return false"
								    >
									<track kind="captions" />
									<source :src="item.url" type="video/mp4">
								</video>
								<video v-if="!isMobile"
								    controls
								    :poster="item.thumb"
								    preload="none"
								    muted
								    :alt="item.title"
								    :style="getVideoAspectStyle(item)"
								    controlslist="nodownload"
								    oncontextmenu="return false"
								    :src="item.url"
								    >
									<track kind="captions" />
								</video>
							</div>
							<div class="video_name">
								<span>{{item.title}}</span>
							</div>
						</div>
					</div>
				</section>
				<div class="loadmore">
					<Loading :is-loading="isPicLoading"></Loading>
					<span class="more" @click="loadMore()" v-if="!nomore">{{$t('loadmore')}}</span>
					<span class="end" v-if="nomore">- {{$t('theEnd')}} -</span>
				</div>
			</div>
		</div>
		<Footer/>
		
	</div>
</template>

<script>
	import topic_video from './topic_video_controller';
	export default topic_video;
</script>

<style src="@/assets/css/topic_video.css" scoped>
	/*@import url("@/assets/css/style.css");全局引用css*/
	/*@import '@/assets/css/style.css';*/
</style>